import { useMutation } from '@tanstack/react-query';
import { rejectImport } from 'config/requests/bankOperations';

export function useRejectImport() {
  return useMutation({
    mutationFn: ({ id }: { id: string }) => rejectImport(id),
  });
}
